/*------------------------------------*\
    MODULES
\*------------------------------------*/
import $ from "jquery";

/*------------------------------------*\
    LOADING BUTTON MODULE
\*------------------------------------*/
class LoadingButton {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
    }

    init() {
        let self = this;

        var elem = $(this);

        elem.on('click', function(evt) {
            console.log(evt);
            elem.prop('disabled', true);
            elem.addClass('is-loading');
        });
    }
}

export default LoadingButton;